module.exports = __webpack_public_path__ + "static/media/image_42.d95b895c.png";